import {
  buildMidAutumnDismissalKey, clearMidAutumnFallback, isMidAutumnActive,
  isMidAutumnDismissed, MID_AUTUMN_DISMISS_EVENT, nextMidAutumnRefreshDelay,
  readMidAutumnDismissal, writeMidAutumnDismissal
} from '@/utils/midAutumnPromotion'

export default {
  data() {
    return { midAutumnNow: Date.now(), midAutumnDismissedAt: 0, midAutumnLocalDismissedAt: 0 }
  },
  computed: {
    midAutumnActive() { return isMidAutumnActive(this.midAutumnNow) },
    midAutumnDismissalKey() {
      return buildMidAutumnDismissalKey(this.$store.getters.axiosParamData)
    },
    midAutumnBannerVisible() {
      return this.midAutumnActive && !isMidAutumnDismissed(this.midAutumnDismissedAt, this.midAutumnNow)
    }
  },
  watch: {
    midAutumnDismissalKey() {
      this.midAutumnLocalDismissedAt = 0
      this.refreshMidAutumnPromotion()
    },
    '$route.fullPath'() { this.refreshMidAutumnPromotion() }
  },
  methods: {
    refreshMidAutumnPromotion() {
      clearTimeout(this.midAutumnTimer)
      this.midAutumnNow = Date.now()
      this.midAutumnDismissedAt = this.midAutumnDismissalKey
        ? readMidAutumnDismissal(this.midAutumnDismissalKey, this.midAutumnNow)
        : this.midAutumnLocalDismissedAt
      if (typeof window !== 'undefined') {
        this.midAutumnTimer = setTimeout(this.refreshMidAutumnPromotion,
          nextMidAutumnRefreshDelay(this.midAutumnNow, this.midAutumnDismissedAt))
      }
    },
    dismissMidAutumnPromotion() {
      this.midAutumnLocalDismissedAt = Date.now()
      writeMidAutumnDismissal(this.midAutumnDismissalKey, this.midAutumnLocalDismissedAt)
      this.refreshMidAutumnPromotion()
      window.dispatchEvent(new Event(MID_AUTUMN_DISMISS_EVENT))
    },
    syncMidAutumnStorage(event) {
      if (event.key === null || event.key === this.midAutumnDismissalKey) {
        clearMidAutumnFallback(event.key)
        this.refreshMidAutumnPromotion()
      }
    }
  },
  mounted() {
    this.refreshMidAutumnPromotion()
    window.addEventListener('storage', this.syncMidAutumnStorage)
    window.addEventListener(MID_AUTUMN_DISMISS_EVENT, this.refreshMidAutumnPromotion)
    document.addEventListener('visibilitychange', this.refreshMidAutumnPromotion)
  },
  beforeDestroy() {
    clearTimeout(this.midAutumnTimer)
    window.removeEventListener('storage', this.syncMidAutumnStorage)
    window.removeEventListener(MID_AUTUMN_DISMISS_EVENT, this.refreshMidAutumnPromotion)
    document.removeEventListener('visibilitychange', this.refreshMidAutumnPromotion)
  }
}
